<template>
  <v-dialog v-model="dialog" max-width="700px" persistent>
    <v-card>
      <v-card-title>
        <span class="text-h6">
          {{ editando ? 'Editar Sucursal' : 'Registrar Sucursal' }}
        </span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-form ref="formRef">
          <v-row>
            <v-col cols="12" sm="4" class="mt-5">
              <v-text-field
                v-model="codigo"
                label="Código *"
                outlined
                dense
                autocomplete="off"
                :rules="[validacion.required, validacion.codigo]"
                :disabled="editando"
              />
            </v-col>

            <v-col cols="12" sm="8" class="mt-5">
              <v-text-field
                v-model="nombre"
                label="Nombre *"
                outlined
                dense
                autocomplete="off"
                :rules="[validacion.required, validacion.nombre]"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="red" @click="cerrar">Cancelar</v-btn>
        <v-btn text color="green" @click="guardarSucursal">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SucursalesModal',
  props: {
    dialog: Boolean,
    editando: Boolean,
    sucursal: {
      type: Object,
      default: () => null,
    },
  },

  data() {
    return {
      codigo: '',
      nombre: '',
      validacion: {
        required: value => !!value || 'Este campo es obligatorio',
        codigo: value =>
          (value ? value.length <= 3 : true) || 'Máximo 3 caracteres',

       nombre: value =>
          (value ? value.length <= 100 : true) || 'Máximo 100 caracteres',
      },
    };
  },

  watch: {
       dialog(val) {
    if (!val) {
      this.$nextTick(() => {
        this.$refs.formRef?.reset();
      });
      return;
    }
      if (this.editando && this.sucursal) {
        this.codigo = this.sucursal.sucursal_id || '';
        this.nombre = this.sucursal.descripcion_sucursal || '';
      }
    },

    sucursal(nueva) {
      if (!this.dialog) {
        return;
      }
      if (this.editando && nueva) {
        this.codigo = nueva.sucursal_id || '';
        this.nombre = nueva.descripcion_sucursal || '';
      }
    },
  },

  methods: {
    cerrar() {
      this.$emit('close');
    },

    guardarSucursal() {
       if (!this.$refs.formRef.validate()) {
        return;
       }

      this.$emit('guardar', {
        sucursal_id: this.codigo,
        descripcion_sucursal: this.nombre,
      });
    },
  },
};
</script>
